module.exports = __webpack_public_path__ + "img/circulateBlue.55e49913.png";